import Vue from 'vue';
import $ from 'jquery'; //在需要使用的页面中
import moment from 'moment' //引入js日期处理类库

// 时间戳转换工具函数
export function formatSendDateSimple(dateValue) {
  if (!dateValue) {
    return '';
  }

  // 统一处理为 Date 对象
  // 这里的逻辑和之前一样，用于处理秒级/毫秒级时间戳和字符串
  const timestampInMs = typeof dateValue === 'number' && dateValue < 1e12
    ? dateValue * 1000
    : dateValue;

  const date = new Date(timestampInMs);

  // 检查日期是否有效
  if (isNaN(date.getTime())) {
    return '';
  }

  // toISOString() 返回类似 "2025-11-20T09:00:00.000Z" 的字符串
  const isoString = date.toISOString();

  // 1. 截取前10个字符得到 "YYYY-MM-DD"
  const datePart = isoString.substring(0, 10);

  // 2. (可选) 如果需要时分秒，可以截取并拼接
  // const timePart = isoString.substring(11, 19); // "HH:mm:ss"
  // return `${datePart} ${timePart}`; // "YYYY-MM-DD HH:mm:ss"

  return datePart;
}

// 时间选择器 - 输入格式转换
  Vue.directive('dateFormat', {
    inserted: function (el, binding, vnode) {
      const { value: _obj } = binding
      const { context: _this, data } = vnode
      const { expression: key } = data.model
      let arr = []
      const modelValue = function(value,len) {
        // 判断输入的时间为几位数，正则匹配相应的事件格式。可直接采用moment转换,更直接。
        if(value.length>5&&value.length<11) {
          value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3') // 格式化输入格式,2021-03-01
        }else if(value.length>11&&value.length<13){
          value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3 $4:$5') // 格式化输入格式,2021-03-01 09:50
        }else if(value.length>12){
          value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3 $4:$5:$6') // 格式化输入格式,2020-03-01 09:50:30
        }else{
          return false
        }
        //const newValue = value.replace(/-/g,"/"); //解决前台new Date（yyyy-MM-dd）转化时间相差8小时的问题,不知道靠不靠谱，改用moment
        //const time = value && value.constructor == String ? new Date(newValue) : value  // 转换时间格式
        const time = value && value.constructor == String ? moment(value) : value  // 转换时间格式
        // console.log(999,time,value)
        let keys = key.split('.')
        if(arr.length === len) {
          arr = [];
        }
        arr.push(time)
        // 判断指令是否有传值，是否有传数组的名称跟索引值，原因：转换出来的时间控件_this[key1][key2]取不到绑定的相关值
        if(!_obj) {
          // 处理简单的绑定
          if (keys && keys.length >= 2) {
            const [key1, key2, key3, key4] = keys
            if (key4) {
              _this[key1][key2][key3][key4] = len===2?arr:time;
            } else if (key3) {
              _this[key1][key2][key3] = len===2?arr:time;
            } else {
              _this[key1][key2] = len===2?arr:time;
            }
          }else{
            _this[key] = len===2?arr:time;
          }
        }else{
          // 处理循环中的时间控件绑定，需要传值，再去相应的数组中查找相应的字段赋值
          let objKey =  _obj.obj.split('.')
          if (objKey && objKey.length >= 2) {
          // 解构赋值
          const [flag1, flag2, flag3, flag4] = objKey;
          // _obj.index：索引，_obj.modelName：绑定的字段名
            if (flag4) {
              _this[flag1][flag2][flag3][flag4][_obj.index][_obj.modelName] = len===2?arr:time;
            } else if (flag3) {
              _this[flag1][flag2][flag3][_obj.index][_obj.modelName] = len===2?arr:time;
            } else {
              _this[flag1][flag2][_obj.index][_obj.modelName] = len===2?arr:time;
            }
          }else{
            _this[objKey][_obj.modelName] = len===2?arr:time;
          }
        }
      };
      if(_this && _this._isVue) {
        const $this = $($(el).children('input')[0])
        const $this2 = $($(el).children('input')[1])
        // 判断是范围的还是单个独立的日期时间控件，范围的两个输入框都要绑定change事件
        if($(el).children('input').length>1) {
          $this.on('change', function() {
            let value = $this.val()
            modelValue(value,2);
          })
          $this2.on('change', function() {
            let value = $this2.val()
            modelValue(value,2);
          })
        }else{
          $this.on('change', function() {
            let value = $this.val()
            modelValue(value,1);
          })
        }
      }
    }
  })


// 时间戳转换过滤器
Vue.filter('timestampToDate', function(timestamp, format = 'YYYY-MM-DD') {
  return timestampToDate(timestamp, format);
})



// 时间选择器 - 多种输入格式
//     Vue.directive('dateFormat', {
//       inserted: function (el, binding, vnode) {
//         const { value: _obj } = binding
//         const { context: that, data } = vnode
//         const { expression: key } = data.model

//         if(that && that._isVue) {
//           const $this = $($(el).children('input')[0])

//           $this.on('change', function() {
//             let value = $this.val()

//             // 中文日期
//             if (!value.match(/\d{1,}/g)) {
//               const chinaNum = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九']
//               const wList = [...value].map(w => {
//                 const idx = chinaNum.findIndex(p => p == w)
//                 return idx == -1 ? w : idx
//               })
//               value = wList.join('')
//             }

//             value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3') // 格式化输入格式

//             const time = value && value.constructor == String ? new Date(value) : value  // 转换时间格式
//             let keys = key.split('.')

//             // 自定义赋值
//             if (_obj) {
//               const { keys: keyList } = _obj
//               keys = keyList
//             }

//             if (keys && keys.length >= 2) {
//               const [key1, key2, key3, key4] = keys
//               if (key4) {
//                 that[key1][key2][key3][key4] = time
//               } else if (key3) {
//                 that[key1][key2][key3] = time
//               } else {
//                 that[key1][key2] = time
//               }
//             } else {
//               that[key] = time
//             }
//           })
//         }
//       }
//     })



// WEBPACK FOOTER //
// ./src/utils/dateFormat.js